import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  dateTimeMenu: {
    '& .MuiMenuItem-root': {
      color: '#2C2D3E',
      padding: '2px 15px 2px 15px',
      fontSize: '13px',
      '&:hover, &:focus': {
        backgroundColor: 'white',
        color: '#3C419A',
      },
    },
    '& .MuiTextField-root': {
      width: '180px',
      padding: '2px',
    },
    '& .MuiPickersStaticWrapper-staticWrapperRoot': {
      flexDirection: 'unset',
      justifyContent: 'center',
    },
    '& .MuiPickersCalendarHeader-switchHeader': {
      display: 'flex',
      flexDirection: 'row',
      '& .MuiPickersCalendarHeader-transitionContainer': {
        order: '-1',
      },
    },
    '& .MuiPickersDay-hidden': {
      opacity: '0.2',
    },
    '& .MuiPickersDay-dayDisabled': {
      color: 'rgba(0, 0, 0, 0.5)',
    },
    '& .MuiPickersDay-daySelected': {
      backgroundColor: '#3C419A',
    },
    '& .dayInSelectedRange': {
      backgroundColor: 'rgba(202, 202, 252, 0.15)',
    },
    '& .firstDayFromRange': {
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
    },
    '& .lastDayFromRange': {
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
    },
  },
  hr: {
    margin: '5px 0px',
  },
  clearText: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '20px',
  },
  clearIcon: {
    display: 'relative',
    margin: '0px 10px',
    width: '18px',
    color: 'rgba(44, 45, 62, 0.8)',
    cursor: 'pointer',
  },
}));
